// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2342":"8378897a","2907":"60b9cd39","4824":"7042a61d"}[chunkId] + ".chunk.css";
};